module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    staticClass: "new-user custom-scroll-bar"
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": "",
      "color": _vm.snackbarColor,
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n  ")]), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-col', {
    staticClass: "profile-pic-col",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('div', {
    staticClass: "load-img-container"
  }, [_c('div', {
    staticClass: "load-img-btn-div"
  }, [_c('v-btn', {
    staticClass: "load-img-btn",
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": _vm.handleFileImport
    }
  }, [_c('v-icon', [_vm._v("\n              photo_camera\n            ")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "load-img-div"
  }, [_c('v-img', {
    staticClass: "profile-pic",
    attrs: {
      "id": "profile-pic",
      "height": "124",
      "width": "124",
      "src": _vm.profilePicSrc
    }
  })], 1)])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-form', {
    ref: "newUserForm",
    staticClass: "mt-7",
    model: {
      value: (_vm.isFormValid),
      callback: function($$v) {
        _vm.isFormValid = $$v
      },
      expression: "isFormValid"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('NewUser.name')) + " *"),
      "title": ((_vm.$t('NewUser.name')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "requiredRules": "",
      "rules": _vm.$ponceConfig.requiredRules,
      "required": "",
      "maxlength": "50",
      "hide-details": ""
    },
    on: {
      "blur": _vm.parseNames
    },
    model: {
      value: (_vm.userData.name),
      callback: function($$v) {
        _vm.$set(_vm.userData, "name", $$v)
      },
      expression: "userData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('NewUser.lastName')) + " *"),
      "title": ((_vm.$t('NewUser.lastName')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "requiredRules": "",
      "rules": _vm.$ponceConfig.requiredRules,
      "required": "",
      "maxlength": "50",
      "hide-details": ""
    },
    on: {
      "blur": _vm.parseNames
    },
    model: {
      value: (_vm.userData.lastName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "lastName", $$v)
      },
      expression: "userData.lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "text-right pt-6",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.roles,
      "item-value": "value",
      "item-text": function (item) { return _vm.$t(("Roles." + (item.value))); },
      "label": ((_vm.$t('NewUser.role')) + " *"),
      "title": ((_vm.$t('NewUser.role')) + " *"),
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.requiredRules,
      "required": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.roleChangeHandler
    },
    model: {
      value: (_vm.userData.role),
      callback: function($$v) {
        _vm.$set(_vm.userData, "role", $$v)
      },
      expression: "userData.role"
    }
  })], 1), _vm._v(" "), (_vm.isAdmin) ? _c('v-col', {
    staticClass: "text-right pt-6",
    attrs: {
      "cols": "12",
      "offset-sm": "1",
      "sm": "5"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.organizations,
      "item-value": "value",
      "item-text": function (item) { return item.name; },
      "label": _vm.$t('NewUser.organization'),
      "title": _vm.$t('NewUser.organization'),
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.requiredRules,
      "required": "",
      "hide-details": "",
      "loading": _vm.loadingOrganizations,
      "return-object": ""
    },
    model: {
      value: (_vm.userData.organization),
      callback: function($$v) {
        _vm.$set(_vm.userData, "organization", $$v)
      },
      expression: "userData.organization"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "section-text text-left pt-2"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.permissions')))])])], 1), _vm._v(" "), _vm._l((_vm.getPermissionKeys), function(perm) {
    return _c('v-row', {
      key: ("switch_" + perm),
      staticClass: "permissions-elements flex-nowrap",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-switch', {
      attrs: {
        "inset": "",
        "color": "#00D166",
        "disabled": _vm.userData.permissionsCustomized
      },
      model: {
        value: (_vm.permissions[perm]),
        callback: function($$v) {
          _vm.$set(_vm.permissions, perm, $$v)
        },
        expression: "permissions[perm]"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mb-0 text-start switch-text"
    }, [_vm._v(_vm._s(_vm.$t(("UsersPermissions." + perm))))])], 1)
  }), _vm._v(" "), _c('v-row', {
    staticClass: "pt-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('VuePhoneNumberInput', {
    attrs: {
      "color": "#0098E1",
      "size": "lg",
      "default-country-code": "AR",
      "translations": _vm.phoneInputTranslations
    },
    on: {
      "update": _vm.setPhoneNumber
    },
    model: {
      value: (_vm.phoneNumberInput),
      callback: function($$v) {
        _vm.phoneNumberInput = $$v
      },
      expression: "phoneNumberInput"
    }
  })], 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-6",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-btn', {
    staticClass: "text-none text-h6 font-weight-light",
    attrs: {
      "block": "",
      "color": "#0098E1",
      "large": "",
      "loading": _vm.loading,
      "disabled": (!_vm.isFormValid || !_vm.isPhoneValid),
      "dark": !(!_vm.isFormValid || !_vm.isPhoneValid)
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(_vm.fromNewCampaign || _vm.fromNewField ? _vm.$t('NewUser.register') : _vm.$t('NewUser.next')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-none text-body-2 font-weight-bold",
    attrs: {
      "text": "",
      "small": "",
      "color": "#0098E1"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('NewUser.cancel')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afdd0902","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddUser/NewUser.vue
// module id = 1742
// module chunks = 0